// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vPfoLGPPJe {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.vPfoLGPPJe h4 {
  line-height: 3em;
}
.vPfoLGPPJe .QjCcs08fZa {
  float: left;
  width: 100%;
}
.vPfoLGPPJe .bLP50cBKqy {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.vPfoLGPPJe .bLP50cBKqy:hover {
  cursor: pointer;
}
.vPfoLGPPJe .bLP50cBKqy:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.rnCTWjMiWE .FLdB3J5H0I:focus {
  outline: none;
}
.rnCTWjMiWE .FLdB3J5H0I.F0vy137KMf.mJwp63dYmM {
  background: #375A88;
}
.rnCTWjMiWE .FLdB3J5H0I.F0vy137KMf.mJwp63dYmM span {
  color: #fff;
}
.rnCTWjMiWE .mJwp63dYmM {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.rnCTWjMiWE .mJwp63dYmM:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.rnCTWjMiWE input {
  height: 38px;
  min-width: 220px;
}
.bLP50cBKqy.IXgXzbimkW {
  background: #410102;
}
.bLP50cBKqy.hXpYkT2xcQ {
  background: #911318;
}
.bLP50cBKqy.VL9CNkCShO {
  background: #D8293B;
}
.bLP50cBKqy.BQrwQCKN1a {
  background: #F2373C;
}
.bLP50cBKqy.bmjoXga5py {
  background: #FC4448;
}
.bLP50cBKqy.jQgmm1anGd {
  background: #ED535E;
}
.bLP50cBKqy.KAAOKXSiy2 {
  background: #E34926;
}
.bLP50cBKqy.bDgilRCDBa {
  background: #FC562B;
}
.bLP50cBKqy.P_UkJb4UBv {
  background: #FC6722;
}
.bLP50cBKqy.l6ou12qXd8 {
  background: #FD7F24;
}
.bLP50cBKqy.W25OjfZVec {
  background: #FD8D26;
}
.bLP50cBKqy.qPtUTHWQIY {
  background: #EC9C3E;
}
.bLP50cBKqy.PPow3xGxns {
  background: #0e673a;
}
.bLP50cBKqy.o3Ryt_9mte {
  background: #208740;
}
.bLP50cBKqy.jVfWVZMDM5 {
  background: #239718;
}
.bLP50cBKqy.Ly6lRy285U {
  background: #55A84D;
}
.bLP50cBKqy.ZT1gVf3psB {
  background: #4BBE5A;
}
.bLP50cBKqy.htbTWhtRbL {
  background: #0CCA6A;
}
.bLP50cBKqy.yV0IqkufTo {
  background: #0A3C64;
}
.bLP50cBKqy.AR3NUloErl {
  background: #0d487a;
}
.bLP50cBKqy.FvKBvw5ehA {
  background: #10538d;
}
.bLP50cBKqy.bfmiclPCGg {
  background: #115A99;
}
.bLP50cBKqy.JLhrK9zCcX {
  background: #3387E2;
}
.bLP50cBKqy.WRtfHX7t4I {
  background: #1BA9CF;
}
.bLP50cBKqy.Xw1EaeUMCE {
  background: #d27c02;
}
.bLP50cBKqy.yoQhBrQdv5 {
  background: #fb9402;
}
.bLP50cBKqy.WmTm9uxXZq {
  background: #FD9B30;
}
.bLP50cBKqy.b8_T1Rg65a {
  background: #FDBE2D;
}
.bLP50cBKqy.R9f65q5GOk {
  background: #FED831;
}
.bLP50cBKqy.OODy19tuCB {
  background: #FFFD38;
}
.bLP50cBKqy.robb_I1xJw {
  background: #2D215C;
}
.bLP50cBKqy.rRziLfrSoa {
  background: #483C83;
}
.bLP50cBKqy.QFajmNth8g {
  background: #58518d;
}
.bLP50cBKqy.cTGtA8AA4K {
  background: #7068A9;
}
.bLP50cBKqy.sdhKtifdML {
  background: #7f78b2;
}
.bLP50cBKqy.mWtPCJyq_O {
  background: #8f88bc;
}
.bLP50cBKqy.COAsZvuuP5 {
  background: #000;
}
.bLP50cBKqy.QriiCVHifH {
  background: #282626;
}
.bLP50cBKqy.EGPKvw8EBN {
  background: #242222;
}
.bLP50cBKqy.nUiKBKRvRT {
  background: #353838;
}
.bLP50cBKqy.ATtoxMCAca {
  background: #666;
}
.bLP50cBKqy.ivDHKzFgsT {
  background: #999;
}
.GMfaAGgPVn {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.GMfaAGgPVn .He0d4zMWR9 {
  display: none;
}
.keWBiayLOh {
  min-width: 800px;
}
.keWBiayLOh .Zk30gR4ZnA {
  position: relative;
  background-color: #375A87;
  padding: 19px 0px 14px 36px;
  min-height: 80px;
}
.keWBiayLOh .Zk30gR4ZnA .IgAqkWfN1q .IdUAWa8HOy {
  font-size: 20px;
}
.keWBiayLOh .FVRUYqv8gD {
  margin-right: 2px;
  font-size: 24px;
}
.keWBiayLOh .zimTTp7yw5 {
  position: absolute;
  top: 12px;
  right: 18px;
}
.keWBiayLOh .Yr9LY1ppEm {
  font-size: 16px;
  text-align: center;
  padding: 32px 216px 32px;
}
.keWBiayLOh .QETkXLDCIc {
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 20px;
}
.keWBiayLOh .QETkXLDCIc > p {
  margin-bottom: 8px;
}
.keWBiayLOh .Yr9LY1ppEm .Oepf__sisU {
  margin-top: 0;
}
.keWBiayLOh .Yr9LY1ppEm .h0HJTqwPt8 {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  justify-content: center;
}
.keWBiayLOh .Yr9LY1ppEm .h0HJTqwPt8 .n1ij0hSxcK {
  font-size: 12px;
}
.keWBiayLOh .Yr9LY1ppEm .h0HJTqwPt8 button {
  font-weight: normal;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `vPfoLGPPJe`,
	"color-row": `QjCcs08fZa`,
	"color-tile": `bLP50cBKqy`,
	"picker-component": `rnCTWjMiWE`,
	"picker-element": `FLdB3J5H0I`,
	"active": `F0vy137KMf`,
	"btn": `mJwp63dYmM`,
	"red-1": `IXgXzbimkW`,
	"red-2": `hXpYkT2xcQ`,
	"red-3": `VL9CNkCShO`,
	"red-4": `BQrwQCKN1a`,
	"red-5": `bmjoXga5py`,
	"red-6": `jQgmm1anGd`,
	"orange-1": `KAAOKXSiy2`,
	"orange-2": `bDgilRCDBa`,
	"orange-3": `P_UkJb4UBv`,
	"orange-4": `l6ou12qXd8`,
	"orange-5": `W25OjfZVec`,
	"orange-6": `qPtUTHWQIY`,
	"green-1": `PPow3xGxns`,
	"green-2": `o3Ryt_9mte`,
	"green-3": `jVfWVZMDM5`,
	"green-4": `Ly6lRy285U`,
	"green-5": `ZT1gVf3psB`,
	"green-6": `htbTWhtRbL`,
	"blue-1": `yV0IqkufTo`,
	"blue-2": `AR3NUloErl`,
	"blue-3": `FvKBvw5ehA`,
	"blue-4": `bfmiclPCGg`,
	"blue-5": `JLhrK9zCcX`,
	"blue-6": `WRtfHX7t4I`,
	"yellow-1": `Xw1EaeUMCE`,
	"yellow-2": `yoQhBrQdv5`,
	"yellow-3": `WmTm9uxXZq`,
	"yellow-4": `b8_T1Rg65a`,
	"yellow-5": `R9f65q5GOk`,
	"yellow-6": `OODy19tuCB`,
	"purple-1": `robb_I1xJw`,
	"purple-2": `rRziLfrSoa`,
	"purple-3": `QFajmNth8g`,
	"purple-4": `cTGtA8AA4K`,
	"purple-5": `sdhKtifdML`,
	"purple-6": `mWtPCJyq_O`,
	"black-1": `COAsZvuuP5`,
	"black-2": `QriiCVHifH`,
	"black-3": `EGPKvw8EBN`,
	"black-4": `nUiKBKRvRT`,
	"black-5": `ATtoxMCAca`,
	"black-6": `ivDHKzFgsT`,
	"picker-theme": `GMfaAGgPVn`,
	"arrow-regular": `He0d4zMWR9`,
	"remove-stage-modal__root": `keWBiayLOh`,
	"modal-header__root": `Zk30gR4ZnA`,
	"modal-header__ctn": `IgAqkWfN1q`,
	"modal-header__title": `IdUAWa8HOy`,
	"modal-header__icon": `FVRUYqv8gD`,
	"modal-header__closeBtn": `zimTTp7yw5`,
	"remove-stage-modal__content": `Yr9LY1ppEm`,
	"remove-stage-modal__content--title": `QETkXLDCIc`,
	"remove-stage-modal__stage": `Oepf__sisU`,
	"remove-stage-modal__buttons": `h0HJTqwPt8`,
	"remove-btn__icon": `n1ij0hSxcK`
};
export default ___CSS_LOADER_EXPORT___;
